import { Wrench } from "lucide-react";
import { Helmet } from "react-helmet-async";

const Maintenance = () => (
  <div className="min-h-screen bg-background flex items-center justify-center px-4">
    <Helmet>
      <title>Under Maintenance — NivexA FX</title>
      <meta name="robots" content="noindex,nofollow" />
    </Helmet>
    <div className="max-w-lg w-full text-center space-y-6">
      <div className="mx-auto h-20 w-20 rounded-full bg-primary/10 border border-primary/20 flex items-center justify-center">
        <Wrench className="h-10 w-10 text-primary" />
      </div>
      <h1 className="text-3xl sm:text-4xl font-display font-semibold text-foreground">
        We'll be back shortly
      </h1>
      <p className="text-foreground/70 leading-relaxed">
        Our website is currently undergoing scheduled maintenance.
        We're working to bring everything back online as quickly as possible.
        Thank you for your patience.
      </p>
      <p className="text-sm text-foreground/50">
        For urgent queries, contact{" "}
        <a href="mailto:support@nivexafx.com" className="text-primary hover:underline">
          support@nivexafx.com
        </a>
      </p>
    </div>
  </div>
);

export default Maintenance;
